import { showError } from './common';
import axios from 'axios';
import { store } from 'store/index';
import { LOGIN } from 'store/actions';
import config from 'config';

// 后端地址：统一走同源 /，由 server.js（K8s 集群内）或 CRA proxy（本地开发）代理到后端
const getBaseURL = () => {
  return '/';
};

export const API = axios.create({
  baseURL: getBaseURL()
});

API.interceptors.response.use(
  (response) => {
    if (response.data === undefined) {
      response.data = {};
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      store.dispatch({ type: LOGIN, payload: null });
      window.location.href = config.basename + 'login';
    }

    if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }

    showError(error);
    return Promise.reject(error);
  }
);
